import React, { useEffect } from 'react';
import { closeAddAvenantModal } from '../actions';
import { connect } from 'react-redux';
import { Colors } from '../../../utils';
import { InputText } from '../../../components';
import AddAvenant from '../forms/AddAvenant';


const AddAvenantExecutionModal = (props) => {

    useEffect(() => {
        return ()=> props.dispatch(closeAddAvenantModal())
    }, []);

    switch (props.executionState.addAvenantExecutionModal) {
        case true:
            document.getElementById('openAddAvenantExecutionModalBtn').click()
            break;

        default:
            break;
    }

    return (
        <div>
            <button id="openAddAvenantExecutionModalBtn" data-toggle="modal" data-target="#addAvenantExecutionModal" hidden></button>

            <div class="modal fade" id="addAvenantExecutionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header text-center">
                            <h2 class="modal-title" id="exampleModalLabel">Enregistrement d'un Avenant <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <h5 style={{ color: Colors.white }}>X</h5>
                            </button></h2>

                        </div>

                        <div class="modal-body">
                        <AddAvenant />
                        </div>

                        <div class="modal-footer">
                            <button type="button" id='closeModalBtn' class="btn btn-secondary" data-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}


const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: (action) => { dispatch(action) }
    }
}

const mapStateToProps = state => ({
    executionState: state.executionState,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddAvenantExecutionModal)